import React from 'react';
import styled from '@emotion/styled';
import sizes from 'style/sizes';
import fonts from 'style/fonts';

type TopicsDetailDataProps = {
  category: string;
  data: string;
};

const Container = styled.div`
  display: flex;
  margin-bottom: 44px;
`;

const TopicsDetailDeataText = styled.p`
  font-family: ${fonts.enGothic};
  font-weight: bold;
  font-size: 15px;
  line-height: 1;
  letter-spacing: 0.04em;
  & + & {
    padding-left: ${sizes.margin[17]};
    margin-left: 21px;
    position: relative;
    &::before {
      content: '';
      width: 1px;
      height: 12px;
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      background-color: #333333;
    }
  }
`;

export const TopicsDetailData: React.FC<TopicsDetailDataProps> = props => {
  return (
    <Container {...props}>
      <TopicsDetailDeataText>{props.category}</TopicsDetailDeataText>
      <TopicsDetailDeataText>{props.data}</TopicsDetailDeataText>
    </Container>
  );
};
